
import React, { Component } from 'react';

import { translate } from '../../../base/i18n';
import {
    IconMicrophoneEmptySlash
} from '../../../base/icons';
import { BaseIndicator } from '../../../base/react';

/**
 * The type of the React {@code Component} props of {@link AudioMutedIndicator}.
 */
type Props = {

  /**
   * From which side of the indicator the tooltip should appear from.
   */
  tooltipPosition: string,

  /**
   * Invoked to obtain translated strings.
   */
  t: Function,
};

/**
 * React {@code Component} for showing an audio muted icon with a tooltip.
 *
 * @augments Component
 */
class AudioMutedIndicator extends Component<Props> {
    /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @returns {ReactElement}
   */
    render() {
        return (
            <BaseIndicator
                className = 'audioMuted toolbar-icon'
                icon = { IconMicrophoneEmptySlash }
                iconId = 'mic-disabled'
                iconSize = { 17 }
                tooltipKey = { this.props.t('videothumbnail.mute') }
                tooltipPosition = { 'top' } />
        );
    }
}

export default translate(AudioMutedIndicator);
